import { darkColors, lightColors } from "../../theme/colors";
export var light = {
    background: lightColors.backgroundAlt
};
export var dark = {
    background: darkColors.backgroundAlt
};
